import classNames from 'classnames';
import { ErrorMessage, useField } from 'formik';
import { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

interface Props {
  readonly name?: string;
  readonly siteKey: string;
  readonly dataTestId?: string;
}

const FormCaptcha = forwardRef<ReCAPTCHA, Props>(
  ({ name = 'captcha', siteKey, dataTestId = 'form-captcha' }, ref) => {
    const [, meta, { setValue, setTouched }] = useField(name);
    const hasError = meta.error && meta.touched;

    return (
      <div className="flex flex-col space-y-1" data-testid={dataTestId}>
        <ReCAPTCHA
          ref={ref}
          className={classNames({
            '[&_iframe]:rounded-md [&_iframe]:border [&_iframe]:border-red':
              hasError,
          })}
          sitekey={siteKey}
          onChange={(e: string | null) => {
            setTouched(true);
            setValue(e ?? '');
          }}
          size="normal"
          badge="inline"
        />

        {hasError && (
          <ErrorMessage name={name}>
            {(msg: string) => (
              <span
                className="body-four text-red"
                data-testid="form-captcha-error-message"
              >
                {msg}
              </span>
            )}
          </ErrorMessage>
        )}
      </div>
    );
  }
);

export default FormCaptcha;
